module.exports = __webpack_public_path__ + "img/cup-shop-logo-512x512.dbcd085a.png";